import React, { useEffect, useState } from 'react';
import { getLang, setLang } from '../i18n';

// Tombol ganti bahasa ID ⇄ EN (2026-10-24). data-no-translate: labelnya sendiri jangan ikut diterjemahkan.
// Mode mengambang SELALU tampil di semua ukuran layar (2026-10-25: dulu disembunyikan di HP saat mode ID →
// di HP tidak ada jalan menyalakan EN). Di HP dinaikkan 104px supaya di atas dock bawah (Starhub) & tidak
// menutupi tombol; posisi ikut berubah saat layar diputar/di-resize.
const lebarHp = () => typeof window !== 'undefined' && window.innerWidth < 768;

export default function LangToggle({ style, floating }) {
  const en = getLang() === 'en';
  const [hp, setHp] = useState(lebarHp);
  useEffect(() => {
    if (!floating) return undefined;
    const ubah = () => setHp(lebarHp());
    window.addEventListener('resize', ubah);
    return () => window.removeEventListener('resize', ubah);
  }, [floating]);
  return (
    <button type="button" data-no-translate onClick={() => setLang(en ? 'id' : 'en')}
      title={en ? 'Ganti ke Bahasa Indonesia' : 'Switch to English'}
      style={{ fontSize: 12, fontWeight: 600, padding: '6px 10px', borderRadius: 8, border: '1px solid rgba(127,127,127,0.35)', background: floating ? '#ffffff' : 'transparent', color: floating ? '#111827' : 'inherit', cursor: 'pointer',
        ...(floating ? { position: 'fixed', right: hp ? 12 : 16, bottom: hp ? 104 : 16, zIndex: 9000, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' } : {}), ...style }}>
      🌐 {en ? 'EN' : 'ID'} → {en ? 'ID' : 'EN'}
    </button>
  );
}
